import { ColumnDef } from '@tanstack/react-table'
import { DateComponent } from 'app/components/DateComponent'
import { ContactCell } from 'app/components/shared/ContactCell'
import { AnchorCell } from 'app/components/table/AnchorCell'
import { locationColumn } from 'app/table-columns/sharedContactColumns'
import { currentUrlWithParam } from 'lib/currentUrlWithParam'
import { ContactJson } from 'app/types/entities'
import { TransactionWithContact } from 'app/types/transaction'

export const defaultColumns = (
  contactHandler: (contactId: string, patientIds?: string[]) => void,
): ColumnDef<TransactionWithContact, any>[] => [
  {
    id: `Contact`,
    accessorKey: `contactName`,
    header: `Contact`,
    enableResizing: true,
    meta: {
      group: `General`,
      defaultVisible: true,
      pinned: true,
      onOpen: (row) => contactHandler(row.contactId!, row.contactPatientIds),
      ControlledComponent: (row) => (
        <AnchorCell
          href={currentUrlWithParam(`drawer`, row?.contactId!)}
          clickHandler={() => contactHandler(row?.contactId!)}
        >
          <ContactCell contact={{ name: row?.contactName, id: row?.contactId } as ContactJson} />
        </AnchorCell>
      ),
    },
    enableSorting: false,
    enableHiding: false,
    minSize: 100,
  },
  locationColumn<TransactionWithContact>(),
  {
    id: `Transaction Date`,
    accessorKey: `transactionDate`,
    header: `Transaction Date`,
    minSize: 120,
    cell: (props) => <DateComponent value={props.row.original.transactionDate} dateOnly />,
    meta: {
      group: `PMS`,
      defaultVisible: true,
    },
    enableSorting: false,
  },
  {
    id: `Procedure Code`,
    accessorKey: `procedureCode`,
    header: `Procedure Code`,
    meta: {
      group: `PMS`,
      defaultVisible: true,
    },
    enableSorting: false,
  },
  {
    id: `Amount`,
    accessorFn: (row) => row.amount,
    cell: (info) =>
      `${info.getValue().toLocaleString(`en-US`, {
        style: `currency`,
        currency: `USD`,
        maximumFractionDigits: 0,
      })}`,
    header: `Amount`,
    meta: {
      group: `PMS`,
      defaultVisible: true,
    },
    enableSorting: false,
  },
]
